import analytics from './mutations/analytics';
import billing from './mutations/billing';
import dashboard from './mutations/dashboard';
import defaultState from './state';
import player from './mutations/player';
import product from './mutations/product';
import show from './mutations/show';
import user from './mutations/user';

export default {
    /**
     * Resets state
     *
     * @param {object} state  Vuex state.
     */
    resetState(state) {
        Object.assign(state, defaultState());
    },

    /**
     * Changes UI state
     *
     * @param   {object}  state    Vuex state.
     * @param   {object}  newState New UI state.
     *
     */
    changeUIState(state, newState) {
        state.UIState = {
            ...state.UIState,
            ...newState,
        };
    },

    ...analytics,
    ...billing,
    ...dashboard,
    ...player,
    ...product,
    ...show,
    ...user,
};
